module.exports = __webpack_public_path__ + "pc/img/address.5da20cfc.png";